var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99956 28.0001C6.66622 28.0001 5.60511 27.4834 4.81622 26.4501C4.02733 25.4167 3.79956 24.2667 4.13289 23.0001L6.53289 13.9334C5.79956 13.4667 5.194 12.8334 4.71622 12.0334C4.23845 11.2334 3.99956 10.3334 3.99956 9.33342C3.99956 7.86675 4.52178 6.61119 5.56622 5.56675C6.61067 4.5223 7.86622 4.00008 9.33289 4.00008H19.9996C20.9996 4.00008 21.7551 4.4223 22.2662 5.26675C22.7773 6.11119 22.8107 6.97786 22.3662 7.86675L19.6996 13.2001C19.4551 13.6445 19.1273 14.0001 18.7162 14.2667C18.3051 14.5334 17.844 14.6667 17.3329 14.6667H14.6329L14.2662 16.0001H14.6662C15.044 16.0001 15.3607 16.1279 15.6162 16.3834C15.8718 16.639 15.9996 16.9556 15.9996 17.3334V20.0001C15.9996 20.3779 15.8718 20.6945 15.6162 20.9501C15.3607 21.2056 15.044 21.3334 14.6662 21.3334H12.8662L11.8662 25.0667C11.6218 25.9334 11.144 26.639 10.4329 27.1834C9.72178 27.7279 8.91067 28.0001 7.99956 28.0001ZM25.3329 6.66675L24.4996 4.86675L29.3329 2.66675L30.1329 4.50008L25.3329 6.66675ZM29.3329 16.0001L24.4996 13.8334L25.3329 12.0001L30.1329 14.2001L29.3329 16.0001ZM25.3329 10.3334V8.33342H30.6662V10.3334H25.3329Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanTickets);
export default __webpack_public_path__ + "static/media/scan-tickets.38f16b91a283e61652b90f83d2d70761.svg";
export { ForwardRef as ReactComponent };